<div class="profile-email-list">

    @if (emails.length > 0) {
    @for (email of emails; track $index) {
    <div class="profile-email-list-item"
        [class.profile-email-list-item--label]="email.isForLogin || email.isCarbonCopy">

        <div class="profile-email-list-item-option">
            {{ (emailTypesText.get(email.type) ?? '') | translate }}
        </div>

        <div class="profile-email-list-item-value" [title]="email.emailAddress">
            {{email.emailAddress}}
        </div>

        @if (email.isForLogin) {
        <div class="profile-email-list-item-label" [title]="'EMAILS_LIST.TITLES.LOGIN_EMAIL' | translate">

            <div class="profile-email-list-item-label-text">
                {{ 'EMAILS_LIST.TITLES.LOGIN_EMAIL' | translate }}
            </div>

        </div>
        }

        @if (email.isCarbonCopy) {
        <div class="profile-email-list-item-label" [title]="'EMAILS_LIST.TITLES.CC_ED' | translate">

            <div class="profile-email-list-item-label-text">
                {{ 'EMAILS_LIST.TITLES.CC_ED' | translate }}
            </div>

        </div>
        }

    </div>
    }
    } @else {
    <div class="profile-email-list-empty">
        {{ 'EMAILS_LIST.TITLES.EMPTY' | translate }}
    </div>
    }

</div>